require('../../fhApp/currentUser/currentUser');

angular.module('app.pricing.plans.plansService', [
  'app.currentUser'
])
  .factory('app.pricing.plans.plansService', [
    '$http', '$httpParamSerializerJQLike', '$q', 'currentUser', '$rootScope',
    function ($http, $httpParamSerializerJQLike, $q, currentUser, $rootScope) {
      'use strict';

      let plans = {
        list: null,
        error: null,
        retrieve: function (params, options) {
          if(plans.list) {
            plans.list = null;
          }

          if (typeof options === 'undefined') {
            options = {};
          }
          options = angular.extend({
            sort: true
          }, options);
          params = $httpParamSerializerJQLike(params);

          let deferred = $q.defer();

          $http.get(window.location.api('subscriptions/plans?' + params))
            .then(function (response) {
              let data = response.data;
              let resolve_now = true;

              if (data) {
                if (data.plans) {
                  plans.list = data.plans;

                  plans.list.sort((a,b) => {
                    if (a.unit_price > b.unit_price)
                      return -1;
                    if (a.unit_price < b.unit_price)
                      return 1;
                    return 0;
                  });
                }

                if (data.error) {
                  resolve_now = false;

                  plans.error = data.error;
                  deferred.reject(data.error);
                } else {
                  plans.error = null;
                }
              }

              if (resolve_now) {
                deferred.resolve(data);
              }
            });

          return deferred.promise;
        },
      };
      return plans;
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/pricing/plans/plansService.js